(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gusta-brand-index"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="gusta-brand-index"]';
  var JUMP_SELECTOR = '.gusta-brand-index__jump';
  var LINK_SELECTOR = '.gusta-brand-index__jump-link[href^="#brands-"]';
  var HEADER_SELECTOR = '.shopify-section__header';
  var TARGET_PREFIX = '#brands-';
  var BREATHING_ROOM = 18;
  var SETTLE_DELAY = 120;
  var settleTimer = null;

  function getTarget(hash) {
    if (!hash || hash.indexOf(TARGET_PREFIX) !== 0) return null;
    return document.getElementById(hash.slice(1));
  }

  function getStickyOffset(section) {
    var jump = section.querySelector(JUMP_SELECTOR);
    if (!jump) return 0;

    var header = document.querySelector(HEADER_SELECTOR);
    var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var jumpTop = parseFloat(window.getComputedStyle(jump).top);

    if (!Number.isFinite(jumpTop)) {
      jumpTop = headerBottom;
    }

    return Math.max(headerBottom, jumpTop) + jump.getBoundingClientRect().height + BREATHING_ROOM;
  }

  function scrollToTarget(target) {
    var section = target.closest(SECTION_SELECTOR);
    if (!section) return false;

    var destination = window.scrollY + target.getBoundingClientRect().top - getStickyOffset(section);

    window.scrollTo({
      top: Math.max(0, destination),
      behavior: 'auto'
    });

    return true;
  }

  function stabilizeTarget(target) {
    if (!scrollToTarget(target)) return false;

    // Re-measure immediately after the first jump so Warehouse's sticky
    // header and the A-Z bar are already in their post-scroll positions
    // before the browser paints the final destination.
    scrollToTarget(target);

    window.clearTimeout(settleTimer);

    window.requestAnimationFrame(function () {
      scrollToTarget(target);
    });

    // Keep one short non-animated correction as a safeguard for late sticky
    // header geometry changes without reintroducing a visible smooth bounce.
    settleTimer = window.setTimeout(function () {
      scrollToTarget(target);
    }, SETTLE_DELAY);

    return true;
  }

  function correctHashPosition() {
    var target = getTarget(window.location.hash);
    if (!target) return;

    window.requestAnimationFrame(function () {
      stabilizeTarget(target);
    });
  }

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    var clicked = event.target;
    var link = clicked instanceof Element ? clicked.closest(LINK_SELECTOR) : null;
    if (!link || !link.closest(SECTION_SELECTOR)) return;

    var target = getTarget(link.hash);
    if (!target) return;

    event.preventDefault();

    if (window.location.hash !== link.hash) {
      window.history.pushState(null, '', link.hash);
    }

    stabilizeTarget(target);
  }, true);

  window.addEventListener('hashchange', correctHashPosition);
  window.addEventListener('popstate', correctHashPosition);

  if (window.location.hash.indexOf(TARGET_PREFIX) === 0) {
    if (document.readyState === 'complete') {
      correctHashPosition();
    } else {
      window.addEventListener('load', correctHashPosition, { once: true });
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches(SECTION_SELECTOR) || event.target.querySelector(SECTION_SELECTOR)) {
      correctHashPosition();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gusta-staff-picks-editorial"]) return;
  try {
    
(function(){function init(root){root.querySelectorAll('[data-staff-row]').forEach(function(row){var track=row.querySelector('[data-track]');var controls=row.querySelector('[data-controls]');if(!track||!controls)return;var prev=controls.querySelector('[data-scroll="prev"]');var next=controls.querySelector('[data-scroll="next"]');function update(){var max=track.scrollWidth-track.clientWidth;controls.hidden=max<4;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max-2}controls.addEventListener('click',function(e){var button=e.target.closest('[data-scroll]');if(!button)return;var amount=Math.max(220,track.clientWidth*.78);track.scrollBy({left:button.dataset.scroll==='next'?amount:-amount,behavior:'smooth'})});track.addEventListener('scroll',update,{passive:true});if('ResizeObserver'in window)new ResizeObserver(update).observe(track);update()})}document.querySelectorAll('[data-staff-picks]').forEach(init);document.addEventListener('shopify:section:load',function(e){var root=e.target.querySelector('[data-staff-picks]');if(root)init(root)})})();

  } catch(e) { console.error(e); }
})();
})();
